<main theme>
  @if (maintenance) {
    <app-maintenance></app-maintenance>
  }
  @else if (userLogged == false && !changePasswordRequired) {
    <app-login-controller (loginSucceed)="loginSucceed($event)"></app-login-controller>
  }
  @else if (!userLogged && changePasswordRequired) {
    <app-change-password-controller
      (onPasswordChanged)="loginSucceed($event)"
      (onExit)="changePasswordRequired = false; logout()">
    </app-change-password-controller>
  }
  @else if (userLogged && appVersion) {
    <app-main-panel
      [startUrl]="startUrl"
      [profileStartUrl]="profileStartUrl"
      [loadSession]="loadSession"
      (logoutFlag)="logout()"
      [appVersion]="appVersion">
    </app-main-panel>
  }
</main>
